var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n    "+_vm._s(_vm.t == 1 ? '【单选】':(_vm.t == 2 ? '【多选】' : '【不定项】'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }